import React from "react";
import styled from "styled-components";
// import Link from "next/link";
import { Button, useScrollEvent } from "../../../index";
import { getLogoVariant } from "../AnyfinLogo";

export var LogoCtaToggle = function LogoCtaToggle(_ref) {
  var menuContent = _ref.menuContent,
      wrapLinkLogo = _ref.wrapLinkLogo,
      logoVariant = _ref.logoVariant;

  var _useScrollEvent = useScrollEvent({
    offset: 300
  }),
      showLogo = _useScrollEvent.toggle;

  return React.createElement(
    Wrapper,
    null,
    React.createElement(
      LogoContainer,
      { className: showLogo && "show" },
      wrapLinkLogo(getLogoVariant(logoVariant))
    ),
    React.createElement(
      CtaContainer,
      { className: !showLogo && "show" },
      menuContent.mainCtaElementMobileMenu && menuContent.mainCtaElementMobileMenu
    )
  );
};

var Wrapper = styled.div.withConfig({
  displayName: "LogoCtaToggle__Wrapper",
  componentId: "sc-12f2gkz-0"
})(["height:100%;flex:1;position:relative;margin-left:1rem;overflow:hidden;"]);

var LogoContainer = styled.div.withConfig({
  displayName: "LogoCtaToggle__LogoContainer",
  componentId: "sc-12f2gkz-1"
})(["position:absolute;height:100%;width:56px;display:flex;flex-direction:column;justify-content:center;transition:all 200ms ease-in-out;transform:translateY(-20px);opacity:0;&.show{transform:translateY(0);opacity:1;}"]);

var CtaContainer = styled.div.withConfig({
  displayName: "LogoCtaToggle__CtaContainer",
  componentId: "sc-12f2gkz-2"
})(["position:absolute;height:100%;display:flex;flex-direction:row;justify-content:center;align-items:center;transition:all 200ms ease-in-out,visibility 200ms 0ms linear;transform:translateY(20px);opacity:0;visibility:hidden;&.show{transform:translateY(0);opacity:1;visibility:visible;}"]);